(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('SkipperLevelHolder', SkipperLevelHolder);

    SkipperLevelHolder.$inject = ['$resource'];

    function SkipperLevelHolder ($resource) {
        var resourceUrl =  'api/skipper-level-holders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
